import * as React from "react";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { StatusView } from "affinityUI/features/statusView";

import { queriesApi } from "../../../api";
import { isBioErrorResponse, isFetchBaseQueryError } from "../../../api/types";
import { useAppDispatch } from "../../store";

const ErrorMessage = styled.code`
  color: ${(props) => props.theme.colours.grey[400]};
  display: block;
  margin-top: 1rem;
`;

export const ErrorView: React.FC<
  React.PropsWithChildren<{
    heading?: string;
    error?: Error;
    actions?: React.ReactNode;
    imgSrc?: string;
    clearStore?: boolean;
  }>
> = ({ heading, error, actions, imgSrc, children, clearStore }) => {
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (clearStore) {
      dispatch(queriesApi.util.resetApiState());
    }
  }, [clearStore, dispatch]);
  return (
    <StatusView imgSrc={imgSrc} heading={heading} actions={actions}>
      {children}
      {!isNil(error?.message) && (
        <ErrorMessage>
          <strong>Error message: </strong>
          {error?.message}
        </ErrorMessage>
      )}
      {isFetchBaseQueryError(error) && isBioErrorResponse(error.data) ? (
        <>
          <ErrorMessage>
            <strong>Error code: </strong>
            {error.data.code}
          </ErrorMessage>
          <ErrorMessage>
            <strong>Error message: </strong>
            {error.data.message}
          </ErrorMessage>
          <ErrorMessage>
            <strong>Trace ID: </strong>
            {error.data.traceId}
          </ErrorMessage>
        </>
      ) : null}
    </StatusView>
  );
};
